import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=a70cb050&scoped=true&"
import script from "YD/components/home/DownloadCenter.component?vue&type=script&lang=js&"
export * from "YD/components/home/DownloadCenter.component?vue&type=script&lang=js&"
import style0 from "./DownloadCenter.vue?vue&type=style&index=0&id=a70cb050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70cb050",
  null
  
)

export default component.exports